import { Component, ElementRef, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { faCaretLeft, faCaretRight, faCaretUp, faCaretDown} from '@fortawesome/free-solid-svg-icons';
import { FunctionMenuService } from './function-menu.service';
import { FMenu, FMenuItem } from './fmenu';
import { DomSanitizer } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';

/**
 * 機能メニュー
 * 
 * @export
 * @class FunctionMenuComponent
 * @implements {OnInit}
 */
@Component({
  selector: 'app-function-menu',
  templateUrl: './function-menu.component.html',
  styleUrls: ['./function-menu.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class FunctionMenuComponent implements OnInit {

  @ViewChild("fmenu") fmenu: ElementRef;
  fmenuOpen: boolean = false;
  isMouseOnIt: boolean = false;
  timeoutId: number;
  faCaretLeft = faCaretLeft;
  faCaretRight = faCaretRight;
  faCaretUp = faCaretUp;
  faCaretDown = faCaretDown;

  /** 親メニューオープン(true). */
  parentFmenusOpen: { [key: string]: boolean } = {
  };

  constructor(
    public fmenuService: FunctionMenuService,
    public sanitizer: DomSanitizer
  ) {}

  ngOnInit() {
    this.fmenuService.listener(() => {
      if (0 == this.fmenuService.menus.length) {
        this.fmenuOpen = false;
        for(let i: number = 0; i < this.fmenuService.menus.length ; i++){
          this.parentFmenusOpen[i] = false;
        }
      }
    });
  }

  onMouseLeave() {
    if (this.fmenuOpen) {
      if (environment.fmenuAutoClose) {
        this.timeoutId = window.setTimeout(() => {
          if (!this.isMouseOnIt) {
            this.fmenuOpen = false;
            this.isMouseOnIt = false;
            for(let i: number = 0; i < this.fmenuService.menus.length ; i++){
              this.parentFmenusOpen[i] = false; 
            }
          }
        }, 1300);
      }
    }
    this.isMouseOnIt = false;
  }

  onMouseEnter() {
    if (this.fmenuOpen) {
      this.isMouseOnIt = true;
      clearTimeout(this.timeoutId);
    }
  }

  onToggleMenu() {
    this.fmenuOpen = !this.fmenuOpen;
    this.isMouseOnIt = this.fmenuOpen;
    this.fmenuService.disableMenu();
    if(!this.fmenuOpen){
      for(let i: number = 0; i < this.fmenuService.menus.length ; i++){
        this.parentFmenusOpen[i] = false; 
      }
    }
  }

  onClickMenu(menu: FMenu, item: FMenuItem) {
    this.fmenuOpen = false;
    menu.emitMenuItem(item);
    this.isMouseOnIt = false;
    for(let i: number = 0; i < this.fmenuService.menus.length ; i++){
      this.parentFmenusOpen[i] = false; 
    }
  }
}
